<template>
  <section class="section" style="padding-top: 10px">
    <div class="container rounded-lg" style="background-color: #f7f8f2">
      <div class="row justify-content-center text-center mb-5">
        <div class="" data-aos="fade-up">
          <h2 class="section-heading">POURQUOI NOUS CHOISIR</h2>
        </div>
      </div>
      <div class="row">
        <!--div class="desc"-->
        <div class="col-md-6" data-aos="fade-up" data-aos-delay="">
          <img :src="why" style="width: inherit" />
        </div>
        <div
          class="col-md-6"
          data-aos="fade-up"
          data-aos-delay=""
          style="border-bottom: black solid"
        >
          <p style="color: black">
            Chez Adictator, notre vocation est de vous guider dans votre quête
            de bien-être. Nous croyons en l’importance de considérer l’individu
            dans sa globalité, en prenant en compte à la fois le corps et
            l’esprit. Nous vous accompagnons dans votre démarche, en vous
            proposant un programme complet, que ce soit pour vous débarrasser
            d'une addiction, ou simplement pour apporter du bien-être dans votre
            quotidien. Nous utilisons l'auriculothérapie, une thérapie non
            invasive utilisant un faisceau de lumière de faible puissance pour
            activer les tissus. Elle se concentre sur la stimulation de points
            spécifiques de l'oreille externe pour influencer positivement les
            organes et les systèmes du corps.
          </p>
        </div>
        <!--/div-->
      </div>
      <div class="row" style="justify-content: center; padding: 20px">
        <div
          class="col-md-3"
          data-aos="fade-up"
          data-aos-delay=""
          style="margin-bottom: 20px"
        >
          <div
            class="feature-1 text-center rounded-lg"
            style="
              background-color: #34b64a;
              padding: 20px;
              margin-bottom: 20px;
              height: 100%;
            "
          >
            <div
              class="wrap-icon icon-1"
              style="background: linear-gradient(-45deg, #34b64a, #2d71a2)"
            >
              <i class="bi bi-geo-alt-fill"></i>
            </div>
            <!--h3 class="mb-3 service-name-red">Vaporisateur</h3-->
            <p style="color: black">
              Nous avons des succursales partout en France
            </p>
          </div>
        </div>
        <div
          class="col-md-3"
          data-aos="fade-up"
          data-aos-delay=""
          style="margin-bottom: 20px"
        >
          <div
            class="feature-1 text-center rounded-lg"
            style="
              background-color: #34b64a;
              padding: 20px;
              margin-bottom: 20px;
              height: 100%;
            "
          >
            <div
              class="wrap-icon icon-1"
              style="background: linear-gradient(-45deg, #34b64a, #2d71a2)"
            >
              <i class="bi bi-people"></i>
            </div>
            <!--h3 class="mb-3 service-name-red">Vaporisateur</h3-->
            <p style="color: black">
              Jeunes équipes des entreprises partenaires
            </p>
          </div>
        </div>
        <div
          class="col-md-3"
          data-aos="fade-up"
          data-aos-delay=""
          style="margin-bottom: 20px"
        >
          <div
            class="feature-1 text-center rounded-lg"
            style="
              background-color: #34b64a;
              padding: 20px;
              margin-bottom: 20px;
              height: 100%;
            "
          >
            <div
              class="wrap-icon icon-1"
              style="background: linear-gradient(-45deg, #34b64a, #2d71a2)"
            >
              <i class="bi bi-check-circle-fill"></i>
            </div>
            <!--h3 class="mb-3 service-name-red">Vaporisateur</h3-->
            <p style="color: black">
              Nous vous proposons des équipements à la pointe de la technologie,
              garantissant une qualité supérieure.
            </p>
          </div>
        </div>
        <div
          class="col-md-3"
          data-aos="fade-up"
          data-aos-delay=""
          style="margin-bottom: 20px"
        >
          <div
            class="feature-1 text-center rounded-lg"
            style="
              background-color: #34b64a;
              padding: 20px;
              margin-bottom: 20px;
              height: 100%;
            "
          >
            <div
              class="wrap-icon icon-1"
              style="background: linear-gradient(-45deg, #34b64a, #2d71a2)"
            >
              <i class="bi bi-telephone-fill"></i>
            </div>
            <!--h3 class="mb-3 service-name-red">Vaporisateur</h3-->
            <p style="color: black">
              Nous vous proposons 10 minutes de conseils téléphoniques gratuits
              pour répondre à vos questions et vous guider dans votre démarche..
            </p>
          </div>
        </div>
        <div
          class="col-md-3"
          data-aos="fade-up"
          data-aos-delay=""
          style="margin-bottom: 20px"
        >
          <div
            class="feature-1 text-center rounded-lg"
            style="
              background-color: #34b64a;
              padding: 20px;
              margin-bottom: 20px;
              height: 100%;
            "
          >
            <div
              class="wrap-icon icon-1"
              style="background: linear-gradient(-45deg, #34b64a, #2d71a2)"
            >
              <i class="bi bi-truck"></i>
            </div>
            <!--h3 class="mb-3 service-name-red">Vaporisateur</h3-->
            <p style="color: black">
              Nos équipes peuvent également se déplacer à votre domicile pour
              soigner les personnes ne pouvant se déplacer au cabinet, offrant
              ainsi un service personnalisé et accessible à tous.
            </p>
          </div>
        </div>
        <div
          class="col-md-3"
          data-aos="fade-up"
          data-aos-delay=""
          style="margin-bottom: 20px"
        >
          <div
            class="feature-1 text-center rounded-lg"
            style="
              background-color: #34b64a;
              padding: 20px;
              margin-bottom: 20px;
              height: 100%;
            "
          >
            <div
              class="wrap-icon icon-1"
              style="background: linear-gradient(-45deg, #34b64a, #2d71a2)"
            >
              <i class="bi bi-calendar-heart-fill"></i>
            </div>
            <!--h3 class="mb-3 service-name-red">Vaporisateur</h3-->
            <p style="color: black">12 mois de garantie en cas de rechute</p>
          </div>
        </div>
        <div
          class="col-md-3"
          data-aos="fade-up"
          data-aos-delay=""
          style="margin-bottom: 20px"
        >
          <div
            class="feature-1 text-center rounded-lg"
            style="
              background-color: #34b64a;
              padding: 20px;
              margin-bottom: 20px;
              height: 100%;
            "
          >
            <div
              class="wrap-icon icon-1"
              style="background: linear-gradient(-45deg, #34b64a, #2d71a2)"
            >
              <i class="bi bi-hand-thumbs-up-fill"></i>
            </div>
            <!--h3 class="mb-3 service-name-red">Vaporisateur</h3-->
            <p style="color: black">
              Aucune douleur. La santé passe par l'oreille.
            </p>
          </div>
        </div>
        <div
          class="col-md-3"
          data-aos="fade-up"
          data-aos-delay=""
          style="margin-bottom: 20px"
        >
          <div
            class="feature-1 text-center rounded-lg"
            style="
              background-color: inherit;
              padding: 20px;
              margin-bottom: 20px;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <button
              class="rounded-lg"
              style="background-color: #f21e1e; padding: 20px; border: none"
            >
              En savoir plus
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container rounded-lg">
      <div
        class="rounded-lg"
        style="
          margin: 10px;
          box-shadow: -5px -5px 5px 5px #888888;
          padding: 20px;
        "
      >
        <div class="row justify-content-center text-center mb-5">
          <div class="" data-aos="fade-up">
            <h2 class="">TROUVER UN PRATICIEN</h2>
          </div>
        </div>
        <div class="row">
          <!--div class="desc"-->
          <div class="col-md-8" data-aos="fade-up" data-aos-delay="">
            <p style="color: black">
              Adictator fournit une liste de praticiens qualifiés en
              auriculothérapie. Vous pouvez prendre rendez-vous en utilisant
              Adictator.
            </p>
          </div>
          <div
            class="col-md-4"
            data-aos="fade-up"
            data-aos-delay=""
            style="display: flex; align-items: center; justify-content: center"
          >
            <button
              class="rounded-lg"
              style="background-color: #38b44a; padding: 20px; border: none"
            >
              Trouver un praticien
            </button>
          </div>
          <!--/div-->
        </div>
      </div>
    </div>
    <div class="container rounded-lg">
      <div
        class="rounded-lg"
        style="
          margin: 10px;
          box-shadow: -5px -5px 5px 5px #f3f5f6;
          padding: 20px;
        "
      >
        <div class="row justify-content-center text-center mb-5">
          <div class="" data-aos="fade-up">
            <h2 class="section-heading">FAQs</h2>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-12 justify-content-center text-center flex"
            data-aos="fade-up"
            data-aos-delay=""
          >
            <div class="justify-center flex">
              <VueFaqAccordion :items="myItems" :activeColor="ac" class="justify-center"/>
            </div>
          </div>
          <div
            class="col-md-12 mt-2"
            data-aos="fade-up"
            data-aos-delay=""
            style="display: flex; align-items: center; justify-content: end"
          >
            <button
              class="rounded-lg"
              style="background-color: #38b44a; padding: 20px; border: none"
            >
            See more FAQs
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import tobacco from "@/assets/img/IconCategorie-2-2048x2048.png";
import sugar from "@/assets/img/IconCategorie-4-2048x2048.png";
import stress from "@/assets/img/Taterapi-Icon-1-2048x2048.png";
import pain from "@/assets/img/pain.png";
import weight from "@/assets/img/weight.png";
import vaporizer from "@/assets/img/11.png";
import can from "@/assets/img/IconCategorie-1-2048x2048.png";
import why from "@/assets/img/why.jpg";
import VueFaqAccordion from "vue-faq-accordion";
export default {
  components: {
    VueFaqAccordion,
  },
  data() {
    return {
      ac: "#38b44a",
      myItems: [
        {
          title: "Est-ce que ça marche vraiment ?",
          value:
            "L’auriculothérapie laser fonctionne très bien pour le sevrage tabagique. Des centaines de milliers de personnes ont déjà opté pour cette solution pour arrêter de fumer ou autre. On entend même bien souvent que cela est magique. Bien sûr il faut ajouter à cela un zeste de volonté. Cette solution vous enlève plus de 70 % de l’envie les 30 % autres reste à votre charge.",
          category: "",
        },
        {
          title: "Est-ce que ça fait mal ?",
          value: "Aucune douleur n’est ressenti pendant et après une séance",
          category: "",
        },
        {
          title: "Quel est le risque de rechute ?",
          value:
            "Le risque de rechute ne tient qu’à vous . On vous débranche la prise de l’envie à 70 % à vous de ne pas la reconnecter, mais vous apprécierez tellement votre nouvelle vie de non-fumeur qu’il serait vraiment dommage de replonger pour x ou y raison .",
          category: "",
        },
        {
          title: "Est-ce que c’est remboursé par la sécurité sociale ?",
          value:
            "Malheureusement, la sécurité sociale ne prend pas en charge le remboursement de cette thérapie cela dit certaines mutuelles peuvent rembourser plus de la moitié du montant d’une séance.",
          category: "",
        },
      ],
      tobacco: tobacco,
      sugar: sugar,
      pain: pain,
      vaporizer,
      can,
      stress,
      weight,
      why,
    };
  },
};
</script>

<style scoped>
.service-image {
  width: 120px;
}

.desc {
  display: flex;
  width: 100%;
}

.desc-image {
}
@media screen and (max-width: 768px) {
  .desc {
    flex-direction: column;
  }
}
.service-name-red {
  color: #f21e1e;
  font-size: 30px;
  text-decoration: bold;
}
.service-name-other {
  color: #25652f;
  font-size: 30px;
  text-decoration: bold;
}
</style>
